module.exports = "fragment CartDepartement on DepartementType{__typename id value:id code:codeDept name:nomDept}"